<template lang="html">
  <div class="">
    <div class="vx-row">
      <div class="vx-col lg:w-1/4 sm:w-full">
        <vs-input class="w-full mt-1" label="Costo actual de vivienda" v-model="valores.valor" name="username" v-on:keypress="isNumber($event)"/>
      </div>
      <div class="vx-col lg:w-1/4 sm:w-full">
        <vs-input class="w-full mt-1" label="Restante por pagar" v-model="valores.credito" name="username" v-on:keypress="isNumber($event)"/>
      </div>
      <div class="vx-col lg:w-1/4 sm:w-full">
        <vs-input class="w-full mt-1" label="Pago mensual" v-model="valores.mensualidad" name="username" v-on:keypress="isNumber($event)"/>
      </div>
      <div class="vx-col lg:w-1/4 sm:w-full">
        <label class="text-sm">Tiempo restante en el crédito</label>
        <vs-select v-model="valores.plazoRestante">
          <vs-select-item :key="index" :value="plazoRestante.value" :text="plazoRestante.label" v-for="plazoRestante,index in plazos"/>
        </vs-select>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/2 sm:w-full">
        <label class="text-sm">Plazos a cotizar</label>
        <v-select v-model="valores.plazosACotizar" multiple :closeOnSelect="false" :options="plazos" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>
      <div class="vx-col lg:w-1/4 sm:w-full">
        <label class="text-sm">Esquemas de pago</label>
        <v-select v-model="valores.esquemasACotizar" multiple :closeOnSelect="false" :options="esquemas" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>
    </div>
    <br>
    <vs-button class="w-full" @click="next()" :disabled="!completeInfo">Siguiente</vs-button>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  data(){
		return{
      plazos:[
        { label: '20 Años',  value: '20' },
        { label: '19 Años',  value: '19' },
        { label: '18 Años',  value: '18' },
        { label: '17 Años',  value: '17' },
        { label: '16 Años',  value: '16' },
        { label: '15 Años',  value: '15' },
        { label: '14 Años',  value: '14' },
        { label: '13 Años',  value: '13' },
        { label: '12 Años',  value: '12' },
        { label: '11 Años',  value: '11' },
        { label: '10 Años',  value: '10' },
        { label: '9 Años',  value: '9' },
        { label: '8 Años',  value: '8' },
        { label: '7 Años',  value: '7' },
        { label: '6 Años',  value: '6' },
        { label: '5 Años',  value: '5' },
        { label: '4 Años',  value: '4' },
        { label: '3 Años',  value: '3' },
        { label: '2 Años',  value: '2' },
        { label: '1 Años',  value: '1' },
      ],
      esquemas:[
        { label: 'Pago Fijo',  value: '2' },
        { label: 'Pago creciente',  value: '1' },
      ],
      valores:{
        destino:19,
        valor:'',
        credito:'',
        mensualidad:'',
        plazoRestante:'',
        esquemasACotizar:[{ label: 'Pago Fijo',  value: '2' }],
        plazosACotizar:[{ label: '10 Años',  value: '10' },{ label: '15 Años',  value: '15' },{ label: '20 Años',  value: '20' }],
      },
      key:''
    }
  },
  mounted(){
    this.key=this.$route.params.key
  },
  watch: {
    mensualidad: function(newValue) {
      this.valores.mensualidad= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    valor: function(newValue) {
      this.valores.valor= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    credito: function(newValue) {
      this.valores.credito= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },
  computed:{
     validaValor(){
      return parseFloat(this.valores.valor) > 0
    },
    validaCredito(){
      return parseFloat(this.valores.credito) > 0
    },
    validaMensualidad(){
      return parseFloat(this.valores.mensualidad) > 0
    },
    validaPlazoRestante(){
      return this.valores.plazoRestante > 0
    },
    completeInfo(){
      return this.validaValor && this.validaCredito && this.validaMensualidad && this.validaPlazoRestante
     },
    valor(){
      return this.valores.valor
    },
    credito(){
      return this.valores.credito
    },
    mensualidad(){
      return this.valores.mensualidad
    }
  },
  methods:{
    next(){
      this.$emit('updateValores',this.valores)
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateValores(){
      this.$emit('updateValores',this.valores)
    },
    dameCaso(){
      var objRequestDameCaso = {
        strApiKey: this.key,
        strMetodo: 'DameCaso',
        objCaso: {
         Id: this.id
        }
      }
      this.$axios.post('/',objRequestDameCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let cotizacion=response.data.objContenido;
            this.valores.destino=cotizacion.Destino
            this.valores.plazosACotizar=[]
            this.valores.esquemasACotizar=[]
            this.valores.valor=(cotizacion.ValorInmueble).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.valores.credito=(cotizacion.MontoSolicitado).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.valores.plazoRestante=cotizacion.PlazoRestante
            this.valores.mensualidad= (cotizacion.PagoMensualActual).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            for (var i = 0; i < cotizacion.Plazos.length; i++) {
              this.valores.plazosACotizar.push(cotizacion.Plazos[i]+' Años')
            }
            for (var i = 0; i < cotizacion.Esquemas.length; i++) {
              if (cotizacion.Esquemas[i] == 2) {
                this.valores.esquemasACotizar.push({ label: 'Pago Fijo',  value: '2' })
              }  else if (cotizacion.Esquemas[i] == 1) {
                this.valores.esquemasACotizar.push({ label: 'Pago creciente',  value: '1' })
              }
            }
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        this.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
